import { render } from "./FormConsentimiento.vue?vue&type=template&id=992529f6&scoped=true"
import script from "./FormConsentimiento.vue?vue&type=script&lang=js"
export * from "./FormConsentimiento.vue?vue&type=script&lang=js"

import "./FormConsentimiento.vue?vue&type=style&index=0&id=992529f6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992529f6"]])

export default __exports__